import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styles from 'wienenergiedesignsystem/components/IconCard/IconCard.module.scss';
import Button from 'wienenergiedesignsystem/components/Button/Button';
import Card, { ElevatedAction } from 'wienenergiedesignsystem/components/Card/Card';
import Content from 'wienenergiedesignsystem/components/Content/Content';
import React from 'react';
import classNames from 'classnames';
import Heading from 'wienenergiedesignsystem/components/Heading/Heading';
import FontAwesomeProIcon from 'wienenergiedesignsystem/components/FontAwesome/FontAwesomeProIcon';
import { VisuallyHidden } from 'reakit/VisuallyHidden';
import Link from 'wienenergiedesignsystem/components/Link/Link';
import Image from 'wienenergiedesignsystem/components/Image/Image';

var IconCard = function IconCard(_ref) {
  var _classNames;

  var theme = _ref.theme,
      variant = _ref.variant,
      title = _ref.title,
      glyph = _ref.glyph,
      button = _ref.button,
      description = _ref.description,
      headingSize = _ref.headingSize,
      titleTag = _ref.titleTag,
      contentSize = _ref.contentSize,
      size = _ref.size,
      link = _ref.link,
      icon = _ref.icon,
      limitHeading = _ref.limitHeading,
      isCompact = _ref.isCompact,
      limitText = _ref.limitText,
      as = _ref.as,
      hasAction = _ref.hasAction,
      className = _ref.className,
      date = _ref.date,
      props = _objectWithoutPropertiesLoose(_ref, ["theme", "variant", "title", "glyph", "button", "description", "headingSize", "titleTag", "contentSize", "size", "link", "icon", "limitHeading", "isCompact", "limitText", "as", "hasAction", "className", "date"]);

  var ellipsis = '…';
  return /*#__PURE__*/React.createElement(Card, Object.assign({
    as: as,
    theme: theme,
    variant: "elevated",
    className: classNames(styles.card, className),
    hasAction: hasAction
  }, props), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, styles[theme], styles[variant], styles[size], (_classNames = {}, _classNames[styles.withIcon] = glyph || icon, _classNames))
  }, glyph && /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    className: styles.icon,
    fixedWidth: true,
    icon: glyph,
    role: "presentation"
  }), icon && /*#__PURE__*/React.createElement(Image, {
    className: styles.icon,
    alt: title,
    src: icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, title && /*#__PURE__*/React.createElement(Heading, {
    className: styles.heading,
    theme: ['contrast', 'highlight'].includes(theme) ? 'neutral' : null,
    size: headingSize,
    as: titleTag,
    noSpacing: !description,
    "aria-hidden": !!limitHeading
  }, limitHeading && title.length > limitHeading ? "" + title.substring(0, limitHeading) + ellipsis : title), limitHeading && /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Heading, {
    size: headingSize
  }, title)), description && /*#__PURE__*/React.createElement(Content, {
    noSpacing: isCompact,
    notResponsive: true,
    "aria-hidden": !!limitText,
    size: contentSize,
    className: styles.cardContent,
    withParser: true
  }, limitText && description.length > limitText ? "" + description.substring(0, limitText) + ellipsis : description), limitText && /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Content, {
    notResponsive: true
  }, description)), button && /*#__PURE__*/React.createElement(Button, {
    tabIndex: "-1",
    "aria-label": button.title
  }, button.title)), date && /*#__PURE__*/React.createElement("div", {
    className: styles.date
  }, date)), !button && link && /*#__PURE__*/React.createElement(ElevatedAction, null, /*#__PURE__*/React.createElement(Link, {
    to: link
  }, /*#__PURE__*/React.createElement(Button, {
    tabIndex: "-1",
    "aria-label": "Besuchen",
    shape: "bubble"
  }, /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    icon: "chevron-right",
    role: "presentation"
  })))), !button && !link && hasAction && /*#__PURE__*/React.createElement(ElevatedAction, null, /*#__PURE__*/React.createElement(Button, {
    tabIndex: "-1",
    "aria-label": "Besuchen",
    shape: "bubble"
  }, /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    icon: "chevron-right",
    role: "presentation"
  }))));
};

IconCard.defaultProps = {
  headingSize: 'h5',
  contentSize: 'regular',
  limitHeading: null,
  limitText: null,
  isCompact: false,
  as: 'div',
  description: null,
  button: null,
  title: null,
  glyph: null,
  size: null,
  theme: null,
  variant: null,
  icon: null,
  link: null,
  hasAction: false
};
export default IconCard;